/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Sla_LabelInputs */

const vi_order_sla_label = /** @type {(inputs: Order_Sla_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạn xử lý`)
};

/**

* @param {Order_Sla_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_sla_label = /** @type {((inputs?: Order_Sla_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Sla_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_sla_label(inputs)
});